/* bm_peakExplorer_gpxUpload.js – lokaler GPX-Track und geschützter R2-Upload */
(function () {
  'use strict';

  window.BM = window.BM || {};
  if (window.BM.__peakExplorerGpxUploadLoaded) return;
  window.BM.__peakExplorerGpxUploadLoaded = true;

  const BM_GPX_MAX_FILE_BYTES = 5 * 1024 * 1024;
  const BM_GPX_MAX_POINTS = 50000;
  const BM_GPX_MIN_POINTS = 2;
  const BM_GPX_TURNSTILE_SCRIPT_URL =
    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  const BM_GPX_TURNSTILE_TIMEOUT_MS = 15000;
  const BM_GPX_DEFERRED_SUBMIT_TIMEOUT_MS = 45000;
  const BM_GPX_TURNSTILE_ACTION = 'bm_gpx_upload';
  const BM_GPX_EVENT = 'bm:peakExplorer:gpx-change';
  const BM_GPX_SOURCE_PREFIX = 'bm-gpx-source-';
  const BM_GPX_OUTLINE_PREFIX = 'bm-gpx-outline-';
  const BM_GPX_LINE_PREFIX = 'bm-gpx-line-';
  const BM_GPX_ALLOWED_VERSIONS = new Set(['1.0', '1.1']);
  const BM_GPX_PRINT_LINE_WIDTH_MM = 0.8;
  const BM_GPX_MIN_SCREEN_LINE_WIDTH_PX = 2;
  const BM_GPX_MAX_SCREEN_LINE_WIDTH_PX = 24;
  const BM_GPX_EARTH_CIRCUMFERENCE_M = 40075016.686;
  const BM_GPX_TRACK_BOUNDS_MIN_PADDING_KM = 0.02;
  const BM_GPX_TRACK_BOUNDS_PADDING_RATIO = 0.005;
  const BM_GPX_TRACK_MINIMUM_COVERAGE = 0.5;
  const BM_GPX_KM_PER_LATITUDE_DEGREE = 110.574;
  const BM_GPX_KM_PER_LONGITUDE_DEGREE = 111.320;
  const BM_GPX_DRAW_RETRY_DELAYS_MS = Object.freeze([0, 50, 150, 400, 1000, 2000]);
  const BM_GPX_PRIVATE_FIELD = '_BM GPX Upload-ID';
  const BM_GPX_FILE_FIELD = 'GPS-Track';
  const BM_GPX_POINTS_FIELD = 'GPS-Trackpunkte';
  const BM_GPX_COLOR_FIELD = 'GPS-Track Farbe';
  const BM_GPX_COLORS = Object.freeze({
    orange: { line: '#d04a36', outline: '#ffffff', label: 'Orange' },
    schwarz: { line: '#1c1c1c', outline: '#ffffff', label: 'Schwarz' }
  });
  const BM_GPX_DEFAULT_COLOR = 'orange';
  const BM_GPX_FORM_SELECTOR = 'form[action*="/cart/add"]';

  const BM_GPX_DEBUG_PARAM = 'bm_gpx_debug';

  let bmGpxTurnstilePromise = null;

  function bm_gpxUpload_debugEnabled() {
    try {
      if (window.BM?.bm_3dPreview_debugGpx === true) return true;
      if (window.localStorage?.getItem(BM_GPX_DEBUG_PARAM) === '1') return true;
      return new URLSearchParams(window.location.search).has(BM_GPX_DEBUG_PARAM);
    } catch {
      return false;
    }
  }

  function bm_gpxUpload_debugLog(label, payload) {
    if (!bm_gpxUpload_debugEnabled()) return;
    window.console?.log?.(`[bm_peakExplorer_gpxUpload] ${label}`, payload);
  }

  function bm_gpxUpload_turnstileErrorMessage(errorCode) {
    const code = String(errorCode || '');
    if (code === '110100' || code === '110110') {
      return 'Der GPX-Sicherheitscheck ist im Shop noch nicht korrekt eingerichtet.';
    }
    if (code === '110200') {
      return 'Der GPX-Sicherheitscheck ist für diese Shop-Adresse noch nicht freigeschaltet.';
    }
    if (code === '200500') {
      return 'Der GPX-Sicherheitscheck konnte nicht geladen werden. Bitte deaktiviere testweise Inhaltsblocker und lade die Seite neu.';
    }
    if (code.startsWith('1106') || code.startsWith('300') || code.startsWith('600')) {
      return 'Der GPX-Sicherheitscheck konnte nicht abgeschlossen werden. Bitte lade die Seite neu und versuche es erneut.';
    }
    return 'Der GPX-Sicherheitscheck ist momentan nicht verfügbar. Bitte versuche es später erneut.';
  }

  class BmGpxClientError extends Error {
    constructor(message) {
      super(message);
      this.name = 'BmGpxClientError';
    }
  }

  function bm_gpxUpload_safeHttpsUrl(value) {
    try {
      const url = new URL(String(value || ''), window.location.href);
      const isLocal =
        url.hostname === 'localhost' ||
        url.hostname === '127.0.0.1' ||
        url.hostname === '[::1]';
      if (url.protocol !== 'https:' && !(url.protocol === 'http:' && isLocal)) return '';
      return url.href;
    } catch {
      return '';
    }
  }

  function bm_gpxUpload_loadTurnstile() {
    if (typeof window.turnstile?.render === 'function') return Promise.resolve(window.turnstile);
    if (bmGpxTurnstilePromise) return bmGpxTurnstilePromise;

    bmGpxTurnstilePromise = new Promise((resolve, reject) => {
      let script = document.querySelector('script[data-bm-gpx-turnstile]');
      let timeoutId = null;
      let settled = false;

      const finish = (turnstile, error) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        if (turnstile) resolve(turnstile);
        else reject(error || new Error('Turnstile konnte nicht geladen werden.'));
      };
      const handleLoad = () => {
        if (typeof window.turnstile?.render === 'function') finish(window.turnstile);
        else finish(null, new Error('Turnstile API fehlt.'));
      };
      const handleError = () => finish(null, new Error('Turnstile konnte nicht geladen werden.'));

      if (!script) {
        script = document.createElement('script');
        script.src = BM_GPX_TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.dataset.bmGpxTurnstile = '';
      }
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      if (!script.isConnected) document.head.appendChild(script);
      timeoutId = window.setTimeout(handleError, BM_GPX_TURNSTILE_TIMEOUT_MS);
    }).catch(error => {
      bmGpxTurnstilePromise = null;
      throw error;
    });

    return bmGpxTurnstilePromise;
  }

  function bm_gpxUpload_directChildren(element, localName) {
    return Array.from(element?.children || []).filter(
      child => String(child.localName || '').toLowerCase() === localName
    );
  }

  function bm_gpxUpload_parsePoint(element) {
    const latitude = Number(element.getAttribute('lat'));
    const longitude = Number(element.getAttribute('lon'));
    if (
      !Number.isFinite(latitude) || latitude < -90 || latitude > 90 ||
      !Number.isFinite(longitude) || longitude < -180 || longitude > 180
    ) {
      throw new BmGpxClientError('Die GPX-Datei enthält ungültige Koordinaten.');
    }

    const elevationElement = bm_gpxUpload_directChildren(element, 'ele')[0];
    const elevation = Number(elevationElement?.textContent);
    return [
      longitude,
      latitude,
      Number.isFinite(elevation) && elevation >= -12000 && elevation <= 12000
        ? elevation
        : null
    ];
  }

  function bm_gpxUpload_parseTrackName(root) {
    const namedContainers = [
      ...Array.from(root.getElementsByTagNameNS('*', 'trk')),
      ...Array.from(root.getElementsByTagNameNS('*', 'rte'))
    ];
    for (const container of namedContainers) {
      const name = String(
        bm_gpxUpload_directChildren(container, 'name')[0]?.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim();
      if (name) return name.slice(0, 120);
    }
    return '';
  }

  function bm_gpxUpload_parseDocument(xmlText) {
    if (/<!DOCTYPE|<!ENTITY|<\?xml-stylesheet/i.test(xmlText)) {
      throw new BmGpxClientError('Diese GPX-Datei enthält nicht erlaubte XML-Bestandteile.');
    }

    const documentXml = new DOMParser().parseFromString(xmlText, 'application/xml');
    if (documentXml.querySelector('parsererror')) {
      throw new BmGpxClientError('Die GPX-Datei enthält ungültiges XML.');
    }
    const root = documentXml.documentElement;
    if (String(root?.localName || '').toLowerCase() !== 'gpx') {
      throw new BmGpxClientError('Die Datei ist keine gültige GPX-Datei.');
    }
    if (!BM_GPX_ALLOWED_VERSIONS.has(String(root.getAttribute('version') || ''))) {
      throw new BmGpxClientError('Unterstützt werden GPX-Dateien in Version 1.0 oder 1.1.');
    }

    const segments = [];
    let pointCount = 0;
    const trackSegments = Array.from(root.getElementsByTagNameNS('*', 'trkseg'));
    trackSegments.forEach(trackSegment => {
      const points = bm_gpxUpload_directChildren(trackSegment, 'trkpt').map(
        bm_gpxUpload_parsePoint
      );
      pointCount += points.length;
      if (points.length >= BM_GPX_MIN_POINTS) segments.push(points);
    });
    const routes = Array.from(root.getElementsByTagNameNS('*', 'rte'));
    routes.forEach(route => {
      const points = bm_gpxUpload_directChildren(route, 'rtept').map(
        bm_gpxUpload_parsePoint
      );
      pointCount += points.length;
      if (points.length >= BM_GPX_MIN_POINTS) segments.push(points);
    });

    if (pointCount > BM_GPX_MAX_POINTS) {
      throw new BmGpxClientError(
        `Die GPX-Datei darf höchstens ${BM_GPX_MAX_POINTS.toLocaleString('de-DE')} Punkte enthalten.`
      );
    }
    if (!segments.length || pointCount < BM_GPX_MIN_POINTS) {
      throw new BmGpxClientError(
        'Die GPX-Datei enthält keinen Track oder keine Route mit mindestens zwei Punkten.'
      );
    }

    return Object.freeze({
      name: bm_gpxUpload_parseTrackName(root),
      segments: Object.freeze(
        segments.map(segment => Object.freeze(segment.map(point => Object.freeze(point))))
      ),
      pointCount
    });
  }

  async function bm_gpxUpload_readFile(file) {
    if (!file || !/\.gpx$/i.test(String(file.name || ''))) {
      throw new BmGpxClientError('Bitte wähle eine Datei mit der Endung .gpx.');
    }
    if (file.size <= 0 || file.size > BM_GPX_MAX_FILE_BYTES) {
      throw new BmGpxClientError('Die GPX-Datei darf höchstens 5 MB groß sein.');
    }

    let xmlText;
    try {
      xmlText = new TextDecoder('utf-8', { fatal: true }).decode(await file.arrayBuffer());
    } catch {
      throw new BmGpxClientError('Die GPX-Datei muss als UTF-8 gespeichert sein.');
    }
    return bm_gpxUpload_parseDocument(xmlText);
  }

  function bm_gpxUpload_geoJson(track) {
    return {
      type: 'FeatureCollection',
      features: track
        ? track.segments.map(segment => ({
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'LineString',
              coordinates: segment.map(point => [point[0], point[1]])
            }
          }))
        : []
    };
  }

  function bm_gpxUpload_trackBounds(track) {
    const bounds = [Infinity, Infinity, -Infinity, -Infinity];
    for (const segment of track?.segments || []) {
      for (const point of segment || []) {
        const longitude = Number(point?.[0]);
        const latitude = Number(point?.[1]);
        if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) continue;
        bounds[0] = Math.min(bounds[0], longitude);
        bounds[1] = Math.min(bounds[1], latitude);
        bounds[2] = Math.max(bounds[2], longitude);
        bounds[3] = Math.max(bounds[3], latitude);
      }
    }
    return bounds.every(Number.isFinite) ? bounds : null;
  }

  function bm_gpxUpload_nearestTrackPoint(track, target) {
    const targetLongitude = Number(target?.[0]);
    const targetLatitude = Number(target?.[1]);
    if (!Number.isFinite(targetLongitude) || !Number.isFinite(targetLatitude)) return null;

    const cosLatitude = Math.max(
      0.01,
      Math.cos((targetLatitude * Math.PI) / 180)
    );
    let nearestPoint = null;
    let nearestDistanceSquared = Infinity;
    for (const segment of track?.segments || []) {
      for (const point of segment || []) {
        const longitude = Number(point?.[0]);
        const latitude = Number(point?.[1]);
        if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) continue;

        const deltaX =
          (longitude - targetLongitude) *
          BM_GPX_KM_PER_LONGITUDE_DEGREE *
          cosLatitude;
        const deltaY =
          (latitude - targetLatitude) * BM_GPX_KM_PER_LATITUDE_DEGREE;
        const distanceSquared = deltaX * deltaX + deltaY * deltaY;
        if (distanceSquared < nearestDistanceSquared) {
          nearestDistanceSquared = distanceSquared;
          nearestPoint = [longitude, latitude];
        }
      }
    }
    return nearestPoint;
  }

  function bm_gpxUpload_polygonArea(polygon) {
    let area = 0;
    for (let index = 0; index < polygon.length; index += 1) {
      const current = polygon[index];
      const next = polygon[(index + 1) % polygon.length];
      area += current[0] * next[1] - next[0] * current[1];
    }
    return Math.abs(area) / 2;
  }

  function bm_gpxUpload_clipPolygon(polygon, axis, limit, keepGreater) {
    const result = [];
    const coordinate = point => point[axis];
    const inside = point => keepGreater ? coordinate(point) >= limit : coordinate(point) <= limit;
    const intersection = (start, end) => {
      const difference = coordinate(end) - coordinate(start);
      if (Math.abs(difference) <= Number.EPSILON) return start.slice();
      const factor = (limit - coordinate(start)) / difference;
      return [
        start[0] + (end[0] - start[0]) * factor,
        start[1] + (end[1] - start[1]) * factor
      ];
    };

    for (let index = 0; index < polygon.length; index += 1) {
      const start = polygon[index];
      const end = polygon[(index + 1) % polygon.length];
      const startInside = inside(start);
      const endInside = inside(end);
      if (startInside && endInside) result.push(end);
      else if (startInside && !endInside) result.push(intersection(start, end));
      else if (!startInside && endInside) {
        result.push(intersection(start, end), end);
      }
    }
    return result;
  }

  function bm_gpxUpload_trackCoverage(selection, bounds) {
    const selectionCenter = selection?.center;
    const selectionWidthKm = Number(selection?.widthKm);
    const selectionHeightKm = Number(selection?.heightKm);
    if (
      !Array.isArray(selectionCenter) ||
      selectionCenter.length < 2 ||
      !Number.isFinite(Number(selectionCenter[0])) ||
      !Number.isFinite(Number(selectionCenter[1])) ||
      !Number.isFinite(selectionWidthKm) ||
      !Number.isFinite(selectionHeightKm) ||
      selectionWidthKm <= 0 ||
      selectionHeightKm <= 0
    ) {
      return 0;
    }

    const centerLongitude = (bounds[0] + bounds[2]) / 2;
    const centerLatitude = (bounds[1] + bounds[3]) / 2;
    const cosLatitude = Math.max(
      0.01,
      Math.cos((centerLatitude * Math.PI) / 180)
    );
    const paddingKm = Math.max(
      BM_GPX_TRACK_BOUNDS_MIN_PADDING_KM,
      Math.min(selectionWidthKm, selectionHeightKm) *
        BM_GPX_TRACK_BOUNDS_PADDING_RATIO
    );
    const paddingLongitude = paddingKm / (BM_GPX_KM_PER_LONGITUDE_DEGREE * cosLatitude);
    const paddingLatitude = paddingKm / BM_GPX_KM_PER_LATITUDE_DEGREE;
    const expandedBounds = [
      bounds[0] - paddingLongitude,
      bounds[1] - paddingLatitude,
      bounds[2] + paddingLongitude,
      bounds[3] + paddingLatitude
    ];
    const selectionCosLatitude = Math.max(
      0.01,
      Math.cos((Number(selectionCenter[1]) * Math.PI) / 180)
    );
    const angle = -(Number(selection.rotationDeg || 0) * Math.PI) / 180;
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const toSelectionLocal = coordinate => {
      const worldX =
        (coordinate[0] - selectionCenter[0]) *
        BM_GPX_KM_PER_LONGITUDE_DEGREE *
        selectionCosLatitude;
      const worldY =
        (coordinate[1] - selectionCenter[1]) * BM_GPX_KM_PER_LATITUDE_DEGREE;
      return [
        worldX * cosAngle + worldY * sinAngle,
        -worldX * sinAngle + worldY * cosAngle
      ];
    };
    const trackPolygon = [
      [expandedBounds[0], expandedBounds[1]],
      [expandedBounds[2], expandedBounds[1]],
      [expandedBounds[2], expandedBounds[3]],
      [expandedBounds[0], expandedBounds[3]]
    ].map(toSelectionLocal);
    const area = bm_gpxUpload_polygonArea(trackPolygon);
    if (!Number.isFinite(area) || area <= Number.EPSILON) return 0;

    const halfWidth = selectionWidthKm / 2;
    const halfHeight = selectionHeightKm / 2;
    let clipped = trackPolygon;
    clipped = bm_gpxUpload_clipPolygon(clipped, 0, -halfWidth, true);
    clipped = bm_gpxUpload_clipPolygon(clipped, 0, halfWidth, false);
    clipped = bm_gpxUpload_clipPolygon(clipped, 1, -halfHeight, true);
    clipped = bm_gpxUpload_clipPolygon(clipped, 1, halfHeight, false);
    return clipped.length >= 3 ? bm_gpxUpload_polygonArea(clipped) / area : 0;
  }

  function bm_gpxUpload_trackIntersectsSelection(selection, track) {
    const center = selection?.center;
    const widthKm = Number(selection?.widthKm);
    const heightKm = Number(selection?.heightKm);
    if (
      !Array.isArray(center) ||
      !Number.isFinite(Number(center[0])) ||
      !Number.isFinite(Number(center[1])) ||
      !Number.isFinite(widthKm) ||
      !Number.isFinite(heightKm) ||
      widthKm <= 0 ||
      heightKm <= 0
    ) {
      return false;
    }

    const cosLatitude = Math.max(
      0.01,
      Math.cos((Number(center[1]) * Math.PI) / 180)
    );
    const angle = -(Number(selection.rotationDeg || 0) * Math.PI) / 180;
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const halfWidth = widthKm / 2;
    const halfHeight = heightKm / 2;
    const toLocal = coordinate => {
      const worldX =
        (Number(coordinate?.[0]) - Number(center[0])) *
        BM_GPX_KM_PER_LONGITUDE_DEGREE *
        cosLatitude;
      const worldY =
        (Number(coordinate?.[1]) - Number(center[1])) *
        BM_GPX_KM_PER_LATITUDE_DEGREE;
      return [
        worldX * cosAngle + worldY * sinAngle,
        -worldX * sinAngle + worldY * cosAngle
      ];
    };
    const isInside = point =>
      Math.abs(point[0]) <= halfWidth && Math.abs(point[1]) <= halfHeight;
    const segmentIntersects = (start, end) => {
      const deltaX = end[0] - start[0];
      const deltaY = end[1] - start[1];
      let startFactor = 0;
      let endFactor = 1;
      const boundaries = [
        [-deltaX, start[0] + halfWidth],
        [deltaX, halfWidth - start[0]],
        [-deltaY, start[1] + halfHeight],
        [deltaY, halfHeight - start[1]]
      ];
      for (const [direction, distance] of boundaries) {
        if (Math.abs(direction) <= Number.EPSILON) {
          if (distance < 0) return false;
          continue;
        }
        const factor = distance / direction;
        if (direction < 0) startFactor = Math.max(startFactor, factor);
        else endFactor = Math.min(endFactor, factor);
        if (startFactor > endFactor) return false;
      }
      return true;
    };

    for (const segment of track?.segments || []) {
      let previous = null;
      for (const coordinate of segment || []) {
        const point = toLocal(coordinate);
        if (!Number.isFinite(point[0]) || !Number.isFinite(point[1])) continue;
        if (isInside(point) || (previous && segmentIntersects(previous, point))) return true;
        previous = point;
      }
    }
    return false;
  }

  function bm_peakExplorer_attachGpxUpload({ root, map, onStatus, enabled = true }) {
    if (!root || !map) return null;

    const sectionId = String(root.dataset.sectionId || 'default');
    const endpoint = bm_gpxUpload_safeHttpsUrl(root.dataset.gpxUploadEndpoint);
    const turnstileEnabled = root.dataset.gpxTurnstileEnabled === 'true';
    const siteKey = String(root.dataset.gpxTurnstileSiteKey || '').trim();
    const uploadRoot = root.querySelector('[data-role="gpx-upload"]');
    const fileInput = root.querySelector('[data-role="gpx-file"]');
    const fileState = root.querySelector('[data-role="gpx-file-state"]');
    const trackNameElement = root.querySelector('[data-role="gpx-track-name"]');
    const turnstileHost = root.querySelector('[data-role="gpx-turnstile"]');
    const colorInputs = Array.from(root.querySelectorAll('[data-role="gpx-color"]'));
    const removeButton = root.querySelector('[data-role="gpx-remove-button"]');
    const statusElement = root.querySelector('[data-role="gpx-status"]');
    if (!uploadRoot || !fileInput || !removeButton || !statusElement) return null;

    bm_gpxUpload_debugLog('attach', {
      sectionId,
      enabled: Boolean(enabled),
      hostname: window.location.hostname,
      hasEndpoint: Boolean(endpoint),
      turnstileEnabled,
      hasSiteKey: Boolean(siteKey),
      hasTurnstileHost: Boolean(turnstileHost)
    });

    const sourceId = `${BM_GPX_SOURCE_PREFIX}${sectionId}`;
    const outlineId = `${BM_GPX_OUTLINE_PREFIX}${sectionId}`;
    const lineId = `${BM_GPX_LINE_PREFIX}${sectionId}`;
    let selectedFile = null;
    let track = null;
    let upload = null;
    let turnstileApi = null;
    let turnstileWidgetId = null;
    let turnstileToken = '';
    let turnstileReadyPromise = null;
    let automaticUploadRequested = false;
    let parseGeneration = 0;
    let uploadController = null;
    let trackDrawGeneration = 0;
    const trackDrawTimeoutIds = new Set();
    let destroyed = false;
    let isEnabled = Boolean(enabled);
    let deferredSubmit = null;
    let deferredSubmitTimeoutId = null;

    function setStatus(message, state = '') {
      statusElement.textContent = message;
      if (state) statusElement.dataset.state = state;
      else delete statusElement.dataset.state;
    }

    function clearDeferredSubmitTimeout() {
      if (deferredSubmitTimeoutId === null) return;
      window.clearTimeout(deferredSubmitTimeoutId);
      deferredSubmitTimeoutId = null;
    }

    function restoreDeferredSubmitButton(pendingSubmit) {
      const submitter = pendingSubmit?.submitter;
      if (!(submitter instanceof HTMLButtonElement)) return;
      submitter.disabled = Boolean(pendingSubmit.wasDisabled);
      submitter.removeAttribute('aria-busy');
      submitter.classList.remove('loading');
      const label = submitter.querySelector('span');
      if (label && pendingSubmit.labelText) label.textContent = pendingSubmit.labelText;
    }

    function cancelDeferredSubmit(message = '') {
      clearDeferredSubmitTimeout();
      const pendingSubmit = deferredSubmit;
      deferredSubmit = null;
      automaticUploadRequested = false;
      restoreDeferredSubmitButton(pendingSubmit);
      if (message) setStatus(message, 'error');
    }

    function resumeDeferredSubmit() {
      clearDeferredSubmitTimeout();
      const pendingSubmit = deferredSubmit;
      deferredSubmit = null;
      if (!pendingSubmit?.form || destroyed) return;

      restoreDeferredSubmitButton(pendingSubmit);
      window.setTimeout(() => {
        if (destroyed || !upload?.id) return;
        const submitter = pendingSubmit.submitter;
        if (submitter instanceof HTMLElement && submitter.form === pendingSubmit.form) {
          pendingSubmit.form.requestSubmit(submitter);
        } else {
          pendingSubmit.form.requestSubmit();
        }
      }, 0);
    }

    function selectedColorName() {
      const checked = colorInputs.find(input => input.checked);
      const name = String(checked?.value || '').trim().toLowerCase();
      return Object.prototype.hasOwnProperty.call(BM_GPX_COLORS, name)
        ? name
        : BM_GPX_DEFAULT_COLOR;
    }

    function selectedColor() {
      return BM_GPX_COLORS[selectedColorName()];
    }

    function updateTrackColor() {
      if (!map.isStyleLoaded?.()) return;
      const color = selectedColor();
      if (map.getLayer?.(lineId)) {
        map.setPaintProperty(lineId, 'line-color', color.line);
      }
      if (map.getLayer?.(outlineId)) {
        map.setPaintProperty(outlineId, 'line-color', color.outline);
      }
    }

    function handleColorChange() {
      if (!isEnabled) return;
      updateTrackColor();
      syncOrderFields();
      publishTrack();
    }

    function syncButtons() {
      removeButton.hidden = !selectedFile && !track && !upload;
      fileInput.disabled = !isEnabled || Boolean(uploadController);
      removeButton.disabled = !isEnabled || Boolean(uploadController);
      colorInputs.forEach(input => {
        input.disabled = !isEnabled;
      });
    }

    function getProductVariantIds() {
      const ids = new Set();
      const productElement = root.querySelector('script[type="application/json"][data-product]');
      try {
        const product = JSON.parse(productElement?.textContent || '{}');
        product?.variants?.forEach(variant => {
          const id = Number(variant?.id);
          if (Number.isFinite(id)) ids.add(id);
        });
      } catch {
        return ids;
      }
      return ids;
    }

    const productVariantIds = getProductVariantIds();

    function relevantForms() {
      return Array.from(document.querySelectorAll(BM_GPX_FORM_SELECTOR)).filter(form => {
        if (!productVariantIds.size) return true;
        const variantId = Number(form.querySelector('[name="id"]')?.value);
        return Number.isFinite(variantId) && productVariantIds.has(variantId);
      });
    }

    function syncOrderFields() {
      const values = upload
        ? {
            [BM_GPX_PRIVATE_FIELD]: upload.id,
            [BM_GPX_FILE_FIELD]: upload.fileName,
            [BM_GPX_POINTS_FIELD]: String(upload.pointCount),
            [BM_GPX_COLOR_FIELD]: selectedColor().label
          }
        : null;

      relevantForms().forEach(form => {
        [
          BM_GPX_PRIVATE_FIELD,
          BM_GPX_FILE_FIELD,
          BM_GPX_POINTS_FIELD,
          BM_GPX_COLOR_FIELD
        ].forEach(label => {
          let input = Array.from(form.querySelectorAll('input[data-bm-gpx-property]'))
            .find(candidate => candidate.dataset.bmGpxProperty === label);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${label}]`;
            input.dataset.bmGpxProperty = label;
            form.appendChild(input);
          }
          input.value = values?.[label] || '';
          input.disabled = !values;
        });
      });
    }

    function publishTrack() {
      const detail = Object.freeze({
        sectionId,
        selected: Boolean(selectedFile),
        valid: Boolean(track),
        uploaded: Boolean(upload?.id),
        fileName: String(selectedFile?.name || upload?.fileName || ''),
        trackName: String(track?.name || ''),
        uploadId: String(upload?.id || ''),
        color: selectedColorName(),
        pointCount: Number(track?.pointCount || 0),
        segments: track?.segments || Object.freeze([]),
        selection: root.bm_peakExplorer_selection || null
      });
      root.bm_peakExplorer_gpx = detail;
      bm_gpxUpload_debugLog('publishTrack', {
        sectionId,
        rootVisible: !root.hidden && Boolean(root.getClientRects?.().length),
        peakRootCount: document.querySelectorAll('.bm-custom-peak[data-section-id]').length,
        valid: detail.valid,
        segmentCount: detail.segments.length,
        pointCount: detail.pointCount,
        firstPoint: detail.segments[0]?.[0] || null,
        lastPoint:
          detail.segments[detail.segments.length - 1]?.slice(-1)[0] || null,
        selection: detail.selection
          ? {
              sectionId: detail.selection.sectionId,
              center: detail.selection.center,
              widthKm: detail.selection.widthKm,
              heightKm: detail.selection.heightKm,
              rotationDeg: detail.selection.rotationDeg,
              printWidthCm: detail.selection.printWidthCm,
              polygonPointCount: detail.selection.polygon?.length || 0,
              polygon: detail.selection.polygon
            }
          : null
      });
      root.dispatchEvent(new CustomEvent(BM_GPX_EVENT, { bubbles: true, detail }));
    }

    function syncTrackName() {
      if (!trackNameElement) return;
      const name = String(
        track?.name || selectedFile?.name || upload?.fileName || ''
      ).trim();
      trackNameElement.hidden = !name;
      trackNameElement.textContent = name ? `Track: ${name}` : '';
    }

    function trackWidthPixels() {
      const selection = root.bm_peakExplorer_selection;
      const worldWidthMeters = Number(selection?.widthKm) * 1000;
      const printWidthMillimeters = Number(selection?.printWidthCm) * 10;
      const latitude = Number(selection?.center?.[1]);
      const zoom = Number(map.getZoom?.());
      if (
        !Number.isFinite(worldWidthMeters) || worldWidthMeters <= 0 ||
        !Number.isFinite(printWidthMillimeters) || printWidthMillimeters <= 0 ||
        !Number.isFinite(latitude) || !Number.isFinite(zoom)
      ) {
        return BM_GPX_MIN_SCREEN_LINE_WIDTH_PX;
      }

      const physicalWorldWidthMeters =
        worldWidthMeters * (BM_GPX_PRINT_LINE_WIDTH_MM / printWidthMillimeters);
      const metersPerPixel =
        (BM_GPX_EARTH_CIRCUMFERENCE_M * Math.cos((latitude * Math.PI) / 180)) /
        (512 * Math.pow(2, zoom));
      if (!Number.isFinite(metersPerPixel) || metersPerPixel <= 0) {
        return BM_GPX_MIN_SCREEN_LINE_WIDTH_PX;
      }
      return Math.max(
        BM_GPX_MIN_SCREEN_LINE_WIDTH_PX,
        Math.min(BM_GPX_MAX_SCREEN_LINE_WIDTH_PX, physicalWorldWidthMeters / metersPerPixel)
      );
    }

    function updateTrackWidth() {
      if (!map.isStyleLoaded?.()) return;
      const lineWidth = trackWidthPixels();
      if (map.getLayer?.(lineId)) map.setPaintProperty(lineId, 'line-width', lineWidth);
      if (map.getLayer?.(outlineId)) {
        map.setPaintProperty(outlineId, 'line-width', lineWidth + 2.4);
      }
    }

    function alignSelectionToTrackIfNeeded() {
      const selection = root.bm_peakExplorer_selection;
      const bounds = bm_gpxUpload_trackBounds(track);
      if (!selection || !bounds) return;

      const coverage = bm_gpxUpload_trackCoverage(selection, bounds);
      const trackIsVisible = bm_gpxUpload_trackIntersectsSelection(selection, track);
      if (coverage >= BM_GPX_TRACK_MINIMUM_COVERAGE && trackIsVisible) return;

      const boundsCenter = [
        (bounds[0] + bounds[2]) / 2,
        (bounds[1] + bounds[3]) / 2
      ];
      const center = bm_gpxUpload_nearestTrackPoint(track, boundsCenter) || boundsCenter;
      root.dispatchEvent(new CustomEvent('bm:peakExplorer:focus-track', {
        detail: Object.freeze({
          center: Object.freeze(center),
          coverage
        })
      }));
    }

    function addTrackLayer(id, color, width, opacity) {
      map.addLayer({
        id,
        type: 'line',
        source: sourceId,
        layout: { 'line-cap': 'round', 'line-join': 'round' },
        paint: {
          'line-color': color,
          'line-width': width,
          'line-opacity': opacity
        }
      });
    }

    function drawTrack() {
      if (destroyed || !map.isStyleLoaded?.()) return false;
      const data = bm_gpxUpload_geoJson(track);
      try {
        const existingSource = map.getSource(sourceId);
        if (existingSource?.setData) {
          existingSource.setData(data);
        } else {
          map.addSource(sourceId, { type: 'geojson', data });
        }

        const lineWidth = trackWidthPixels();
        const color = selectedColor();
        if (!map.getLayer(outlineId)) {
          addTrackLayer(outlineId, color.outline, lineWidth + 2.4, 0.88);
        }
        if (!map.getLayer(lineId)) {
          addTrackLayer(lineId, color.line, lineWidth, 1);
        }

        updateTrackWidth();
        updateTrackColor();
        map.moveLayer(outlineId);
        map.moveLayer(lineId);
        return Boolean(map.getSource(sourceId) && map.getLayer(outlineId) && map.getLayer(lineId));
      } catch {
        return false;
      }
    }

    function cancelScheduledTrackDraws() {
      trackDrawGeneration += 1;
      trackDrawTimeoutIds.forEach(timeoutId => window.clearTimeout(timeoutId));
      trackDrawTimeoutIds.clear();
    }

    function scheduleTrackDraw(reportFailure = false) {
      cancelScheduledTrackDraws();
      const generation = trackDrawGeneration;
      BM_GPX_DRAW_RETRY_DELAYS_MS.forEach((delay, index) => {
        const timeoutId = window.setTimeout(() => {
          trackDrawTimeoutIds.delete(timeoutId);
          if (destroyed || generation !== trackDrawGeneration) return;
          if (drawTrack()) {
            cancelScheduledTrackDraws();
            return;
          }
          const isLastAttempt = index === BM_GPX_DRAW_RETRY_DELAYS_MS.length - 1;
          if (isLastAttempt && reportFailure && track) {
            setStatus(
              'Der Track wurde gelesen, konnte aber nicht auf der Auswahlkarte dargestellt werden. Bitte die Seite neu laden.',
              'error'
            );
          }
        }, delay);
        trackDrawTimeoutIds.add(timeoutId);
      });
    }

    function resetTurnstile() {
      turnstileToken = '';
      if (turnstileApi && turnstileWidgetId !== null) {
        turnstileApi.reset(turnstileWidgetId);
      }
      syncButtons();
    }

    async function requestAutomaticUpload() {
      if (
        !selectedFile ||
        !track ||
        upload?.id ||
        uploadController ||
        automaticUploadRequested
      ) {
        return;
      }
      if (!endpoint || (turnstileEnabled && !siteKey)) {
        setStatus('Der GPX-Upload ist in den Theme-Einstellungen noch nicht eingerichtet.', 'error');
        return;
      }

      automaticUploadRequested = true;
      if (!turnstileEnabled) {
        void handleUpload();
        return;
      }
      bm_gpxUpload_debugLog('turnstileRequest', {
        hasReadyPromise: Boolean(turnstileReadyPromise),
        hasApi: Boolean(turnstileApi),
        widgetId: turnstileWidgetId
      });
      try {
        await turnstileReadyPromise;
        bm_gpxUpload_debugLog('turnstileReady', {
          hasApi: Boolean(turnstileApi),
          widgetId: turnstileWidgetId
        });
        if (
          destroyed ||
          !automaticUploadRequested ||
          !selectedFile ||
          !track ||
          upload?.id ||
          uploadController
        ) {
          return;
        }

        if (!turnstileApi || turnstileWidgetId === null) {
          cancelDeferredSubmit('Der Sicherheitscheck konnte nicht geladen werden. Bitte versuche es erneut.');
          return;
        }

        if (turnstileToken) {
          void handleUpload();
          return;
        }

        bm_gpxUpload_debugLog('turnstileAwaitingToken', {
          widgetId: turnstileWidgetId
        });
      } catch (error) {
        bm_gpxUpload_debugLog('turnstileRequestError', {
          name: String(error?.name || ''),
          message: String(error?.message || '')
        });
        cancelDeferredSubmit('Der Sicherheitscheck konnte nicht geladen werden. Bitte versuche es erneut.');
      }
    }

    function clearTrack({ keepFile = false, resetSecurityCheck = true } = {}) {
      cancelDeferredSubmit();
      parseGeneration += 1;
      uploadController?.abort();
      uploadController = null;
      automaticUploadRequested = false;
      if (!keepFile) {
        selectedFile = null;
        fileInput.value = '';
      }
      track = null;
      upload = null;
      if (fileState) fileState.textContent = 'Keine Datei';
      syncTrackName();
      cancelScheduledTrackDraws();
      drawTrack();
      syncOrderFields();
      publishTrack();
      if (resetSecurityCheck) resetTurnstile();
      setStatus('GPX 1.0 oder 1.1, maximal 5 MB.');
      syncButtons();
    }

    async function handleFileChange() {
      if (!isEnabled) {
        clearTrack();
        return;
      }
      const file = fileInput.files?.[0] || null;
      const previousUploadWasCompleted = Boolean(upload?.id);
      clearTrack({
        keepFile: true,
        resetSecurityCheck: previousUploadWasCompleted
      });
      selectedFile = file;
      if (!file) {
        clearTrack();
        return;
      }

      const generation = ++parseGeneration;
      if (fileState) fileState.textContent = 'Wird geprüft';
      setStatus('GPX-Datei wird lokal geprüft.');
      syncButtons();
      try {
        const parsedTrack = await bm_gpxUpload_readFile(file);
        if (destroyed || generation !== parseGeneration) return;
        track = parsedTrack;
        if (fileState) fileState.textContent = `${parsedTrack.pointCount.toLocaleString('de-DE')} Punkte`;
        syncTrackName();
        scheduleTrackDraw(true);
        alignSelectionToTrackIfNeeded();
        publishTrack();
        setStatus(
          'Track geprüft. Der Upload wird im Hintergrund vorbereitet.',
          'success'
        );
        void requestAutomaticUpload();
      } catch (error) {
        if (destroyed || generation !== parseGeneration) return;
        track = null;
        if (fileState) fileState.textContent = 'Nicht gültig';
        syncTrackName();
        setStatus(error?.message || 'Die GPX-Datei konnte nicht gelesen werden.', 'error');
        cancelScheduledTrackDraws();
        drawTrack();
        publishTrack();
      }
      syncButtons();
    }

    async function handleUpload() {
      if (
        !isEnabled ||
        !selectedFile ||
        !track ||
        (turnstileEnabled && !turnstileToken) ||
        uploadController
      ) return;
      if (!endpoint || (turnstileEnabled && !siteKey)) {
        setStatus('Der GPX-Upload ist noch nicht vollständig eingerichtet.', 'error');
        return;
      }

      uploadController = new AbortController();
      automaticUploadRequested = false;
      setStatus('GPX-Datei wird geprüft und gespeichert.');
      syncButtons();
      try {
        const headers = {
          'Content-Type': 'application/gpx+xml',
          'X-BM-File-Name': encodeURIComponent(selectedFile.name),
          'X-BM-File-Size': String(selectedFile.size)
        };
        if (turnstileEnabled) headers['X-BM-Turnstile-Token'] = turnstileToken;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers,
          body: selectedFile,
          signal: uploadController.signal,
          credentials: 'omit',
          referrerPolicy: 'strict-origin-when-cross-origin'
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || result?.ok !== true || !result?.upload?.id) {
          throw new BmGpxClientError(
            result?.error?.message || 'Der GPX-Upload konnte nicht abgeschlossen werden.'
          );
        }

        upload = Object.freeze({
          id: String(result.upload.id),
          fileName: String(result.upload.fileName || selectedFile.name),
          pointCount: Number(result.upload.pointCount || track.pointCount),
          expiresAt: String(result.upload.expiresAt || '')
        });
        if (fileState) fileState.textContent = 'Gespeichert';
        setStatus('GPX-Track wurde gespeichert und der Bestellung zugeordnet.', 'success');
        syncOrderFields();
        publishTrack();
        resumeDeferredSubmit();
      } catch (error) {
        if (error?.name === 'AbortError') {
          if (deferredSubmit) {
            cancelDeferredSubmit('Der GPX-Upload wurde unterbrochen. Bitte versuche es erneut.');
          }
          return;
        }
        upload = null;
        syncOrderFields();
        publishTrack();
        setStatus(error?.message || 'Der GPX-Upload ist fehlgeschlagen.', 'error');
        onStatus?.('Der GPX-Track konnte nicht hochgeladen werden.', { isError: true });
        cancelDeferredSubmit(error?.message || 'Der GPX-Upload ist fehlgeschlagen.');
      } finally {
        uploadController = null;
        if (upload?.id) turnstileToken = '';
        else resetTurnstile();
        syncButtons();
      }
    }

    function validateBeforeSubmit(event) {
      if (!isEnabled) return;
      if (!selectedFile || upload?.id) {
        syncOrderFields();
        return;
      }
      if (!relevantForms().includes(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!track) {
        setStatus('Bitte wähle eine gültige GPX-Datei aus.', 'error');
        uploadRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!endpoint || (turnstileEnabled && !siteKey)) {
        setStatus('Der GPX-Upload ist aktuell nicht verfügbar. Bitte versuche es später erneut.', 'error');
        uploadRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (deferredSubmit) return;

      const submitter = event.submitter || null;
      const submitterLabel = submitter instanceof HTMLButtonElement
        ? submitter.querySelector('span')
        : null;
      deferredSubmit = {
        form: event.target,
        submitter,
        wasDisabled: submitter instanceof HTMLButtonElement ? submitter.disabled : false,
        labelText: submitterLabel?.textContent || ''
      };
      if (deferredSubmit.submitter instanceof HTMLButtonElement) {
        deferredSubmit.submitter.disabled = true;
        deferredSubmit.submitter.setAttribute('aria-busy', 'true');
        deferredSubmit.submitter.classList.add('loading');
        if (submitterLabel) submitterLabel.textContent = 'GPX-Track wird hochgeladen …';
      }
      deferredSubmitTimeoutId = window.setTimeout(() => {
        bm_gpxUpload_debugLog('deferredSubmitTimeout', {
          hasUploadRequest: Boolean(uploadController),
          hasTurnstileApi: Boolean(turnstileApi),
          widgetId: turnstileWidgetId,
          automaticUploadRequested,
          hasToken: Boolean(turnstileToken)
        });
        if (uploadController) {
          uploadController.abort();
          cancelDeferredSubmit(
            'Der GPX-Upload hat zu lange gedauert. Bitte prüfe deine Verbindung und versuche es erneut.'
          );
          return;
        }
        cancelDeferredSubmit('Der GPX-Upload wurde nicht gestartet. Bitte lade die Seite neu und versuche es erneut.');
      }, BM_GPX_DEFERRED_SUBMIT_TIMEOUT_MS);
      setStatus('GPX-Track wird gespeichert. Danach wird der Warenkorb automatisch geöffnet.');
      void requestAutomaticUpload();
    }

    function handleStyleLoad() {
      if (!destroyed) scheduleTrackDraw(Boolean(track));
    }

    function handleMapIdle() {
      if (
        !destroyed &&
        track &&
        (!map.getSource(sourceId) || !map.getLayer(outlineId) || !map.getLayer(lineId))
      ) {
        scheduleTrackDraw(true);
      }
    }

    function handleSelectionChange() {
      window.requestAnimationFrame(() => {
        if (!destroyed) updateTrackWidth();
      });
    }

    async function initializeTurnstile() {
      if (!turnstileEnabled || !isEnabled || destroyed) return;
      if (!endpoint || !siteKey || !turnstileHost) {
        setStatus('Der sichere GPX-Upload ist in den Theme-Einstellungen noch nicht eingerichtet.', 'error');
        syncButtons();
        return;
      }
      try {
        bm_gpxUpload_debugLog('turnstileInitialize', {
          hostname: window.location.hostname
        });
        turnstileApi = await bm_gpxUpload_loadTurnstile();
        bm_gpxUpload_debugLog('turnstileApiLoaded', {
          hasRender: typeof turnstileApi?.render === 'function'
        });
        if (destroyed || !isEnabled) {
          turnstileReadyPromise = null;
          return;
        }
        turnstileWidgetId = turnstileApi.render(turnstileHost, {
          sitekey: siteKey,
          action: BM_GPX_TURNSTILE_ACTION,
          execution: 'render',
          appearance: 'always',
          size: 'normal',
          retry: 'auto',
          'retry-interval': 8000,
          'refresh-expired': 'auto',
          'refresh-timeout': 'auto',
          'response-field': false,
          callback: token => {
            turnstileToken = String(token || '');
            bm_gpxUpload_debugLog('turnstileSuccess', {
              hasToken: Boolean(turnstileToken)
            });
            syncButtons();
            if (automaticUploadRequested) void handleUpload();
          },
          'expired-callback': () => {
            bm_gpxUpload_debugLog('turnstileExpired', {});
            turnstileToken = '';
            syncButtons();
          },
          'before-interactive-callback': () => {
            bm_gpxUpload_debugLog('turnstileInteractive', {});
            setStatus('Bitte schließe den sichtbaren Sicherheitscheck für den GPX-Upload ab.');
          },
          'timeout-callback': () => {
            bm_gpxUpload_debugLog('turnstileTimeout', {});
            turnstileToken = '';
            cancelDeferredSubmit(
              'Der GPX-Sicherheitscheck wurde nicht rechtzeitig abgeschlossen. Bitte versuche es erneut.'
            );
            syncButtons();
          },
          'unsupported-callback': () => {
            bm_gpxUpload_debugLog('turnstileUnsupported', {
              userAgent: window.navigator.userAgent
            });
            turnstileToken = '';
            cancelDeferredSubmit(
              'Dieser Browser unterstützt den GPX-Sicherheitscheck nicht. Bitte verwende einen aktuellen Browser.'
            );
            syncButtons();
          },
          'error-callback': errorCode => {
            turnstileToken = '';
            bm_gpxUpload_debugLog('turnstileError', {
              errorCode: String(errorCode || ''),
              hostname: window.location.hostname
            });
            cancelDeferredSubmit(bm_gpxUpload_turnstileErrorMessage(errorCode));
            syncButtons();
            return true;
          }
        });
        bm_gpxUpload_debugLog('turnstileRendered', {
          widgetId: turnstileWidgetId
        });
      } catch (error) {
        bm_gpxUpload_debugLog('turnstileInitializeError', {
          name: String(error?.name || ''),
          message: String(error?.message || '')
        });
        turnstileReadyPromise = null;
        if (isEnabled) {
          setStatus('Der Sicherheitscheck konnte nicht geladen werden.', 'error');
        }
        cancelDeferredSubmit('Der Sicherheitscheck konnte nicht geladen werden. Bitte versuche es erneut.');
      }
    }

    const handleRemoveClick = () => clearTrack();
    fileInput.addEventListener('change', handleFileChange);
    removeButton.addEventListener('click', handleRemoveClick);
    document.addEventListener('submit', validateBeforeSubmit, true);
    map.on('style.load', handleStyleLoad);
    map.on('idle', handleMapIdle);
    map.on('zoom', updateTrackWidth);
    colorInputs.forEach(input => input.addEventListener('change', handleColorChange));
    root.addEventListener('bm:peakExplorer:selection-change', handleSelectionChange);
    syncOrderFields();
    syncButtons();
    if (isEnabled && turnstileEnabled) turnstileReadyPromise = initializeTurnstile();

    return Object.freeze({
      setEnabled(nextEnabled) {
        const shouldEnable = Boolean(nextEnabled);
        if (shouldEnable === isEnabled) {
          syncButtons();
          return isEnabled;
        }

        isEnabled = shouldEnable;
        if (!isEnabled) {
          clearTrack();
        } else {
          syncButtons();
          if (turnstileEnabled && !turnstileReadyPromise) {
            turnstileReadyPromise = initializeTurnstile();
          }
        }
        return isEnabled;
      },
      destroy() {
        destroyed = true;
        cancelDeferredSubmit();
        parseGeneration += 1;
        uploadController?.abort();
        cancelScheduledTrackDraws();
        fileInput.removeEventListener('change', handleFileChange);
        removeButton.removeEventListener('click', handleRemoveClick);
        document.removeEventListener('submit', validateBeforeSubmit, true);
        map.off('style.load', handleStyleLoad);
        map.off('idle', handleMapIdle);
        map.off('zoom', updateTrackWidth);
        colorInputs.forEach(input =>
          input.removeEventListener('change', handleColorChange)
        );
        root.removeEventListener('bm:peakExplorer:selection-change', handleSelectionChange);
        if (turnstileApi && turnstileWidgetId !== null) {
          turnstileApi.remove(turnstileWidgetId);
        }
        delete root.bm_peakExplorer_gpx;
      }
    });
  }

  window.BM.bm_peakExplorer_attachGpxUpload = bm_peakExplorer_attachGpxUpload;
  window.BM.bm_peakExplorer_getGpxTrack = (sectionId = '') => {
    const requestedId = String(sectionId || '');
    const roots = Array.from(document.querySelectorAll('.bm-custom-peak[data-section-id]'));
    const candidates = requestedId
      ? roots.filter(candidate => candidate.dataset.sectionId === requestedId)
      : roots;
    const matchingRoot = candidates
      .filter(candidate => candidate.bm_peakExplorer_gpx?.segments?.length)
      .sort((first, second) => {
        const firstVisible = !first.hidden && first.getClientRects?.().length ? 1 : 0;
        const secondVisible = !second.hidden && second.getClientRects?.().length ? 1 : 0;
        return secondVisible - firstVisible;
      })[0];
    return matchingRoot?.bm_peakExplorer_gpx || null;
  };
})();
